<template>
  <b-card class="card">
      <b-row class="row">
        <div class="time">
          <label :title="$t('rotationTime')">{{$t('rotationTime')}}</label>
          <b-form-input
            class="input-pentagro"
            id="workshift-start-1"
            type="number"
            :placeholder="$t('placeholderRotationTime')"
            min="0"
            v-model.number="screenRotation.secondsrotation"
          />
          
        </div>
          <div class="mt-3">
            <div class="d-flex mobile mb-3">
              <label :title="$t('monitoringScreem')">{{$t('monitoringScreem')}} </label>
              <div class="d-flex ml-3">
                <span class="d-flex but mr-3" @click="selectAll()">
                  <div class="on-active"></div>
                  <label id="checkAll" class="lbl-click" :title="$t('checkAll')">{{$t('checkAll')}}</label>
                </span>
                <span class="d-flex but" @click="unselectAll()">
                  <div class="off-active"></div>
                  <label id="uncheckAll" class="lbl-click" :title="$t('uncheckAll')">{{$t('uncheckAll')}}</label>
                </span>
              </div>
            </div>
            <div>
              <div class="group-buttons" v-if="screenRotation.routes && screenRotation.routes.length > 0">
                <div 
                  v-for="screen in screenRotation.routes" :key="screen.id">
                  <button 
                    :class="{ 'color-button' : true, 'active-button':screen.rotation}"
                    @click="changeStatus(screen)">
                    {{ screen.permission }}
                  </button>
                </div>
              </div>
              <div class="mt-4 not-content" v-else>
                <p :title="$t('loadConfigurations')">{{$t('loadConfigurations')}}</p>
              </div>
            </div>
          </div>
      </b-row>

      <hr>
      <b-row class="groupBtn">
          <div>
            <img
              src="@/assets/salvar.png"
              alt="salvar"
              style="margin-left: 30px;"
              :title="$t('save')"
              @click="save"
            />
            <img
              src="@/assets/apagar.png"
              style="margin-left: 30px;"
              :title="$t('clear')"
              alt="limpar"
              @click="resetForm"
            />
            <img
              id="closeModalPassword"
              class="float-right"
              src="@/assets/sair.png"
              style="margin-left: 20px;"
              :title="$t('exit')"
              alt="Sair"
              @click="$bvModal.hide('screenrotation')"
            />
          </div>
      </b-row>
  </b-card>
</template>

<script>
import { urlMainAPI, showError, defaultSuccess } from "@/global";
import { mapState } from "vuex";
import axios from "axios";
import { updateMyUserPermission } from '../../global';

  export default {
    name:"ScreenRotation",
    computed: mapState(["user"]),
    data() {
      return {
        screenRotation: {},
        screenRotationBKP: {},
      }
    },
    methods:{
      changeStatus(screen){
        screen.rotation = !screen.rotation;
      },

      unselectAll(){
        this.screenRotation.routes.forEach(s => s.rotation = false);
      },

      selectAll(){
        this.screenRotation.routes.forEach(s => s.rotation = true);
      },

      async loadRotationScreen(){
        let system = this.user.role == "GDI" ? "G" : "P";
        let userUnitId = this.user.UnitId;
        let userId = this.user.Id;

        await axios.get(`${urlMainAPI}/getscreenrotationsettings/${system}/${userUnitId}/${userId}`)
          .then((res) => {
            if(res.data){
              this.screenRotation = this.copyFrom(res.data);
              this.screenRotationBKP = this.copyFrom(res.data);
            }
          })
        .catch(console.log);
      },

      save(){
        defaultSuccess(this.$t('salvando-configuracoes'));
          axios.post(`${urlMainAPI}/savescreenrotationsettings`, this.screenRotation)
          .then(async (res) => {
            if(res.data){
              this.screenRotationBKP = this.copyFrom(this.screenRotation);
              defaultSuccess(this.$t('configuracoes-salvas-com-sucesso'));
              await updateMyUserPermission(axios, this.$store);
              setTimeout(location.reload(), 600);
            }
          })
          .catch(err => {
            showError(err);
          });
      },

      resetForm(){
        this.screenRotation = {};
        this.screenRotation = this.copyFrom(this.screenRotationBKP);
        defaultSuccess(this.$t('configuracoes-restauradas'));
      },

      copyFrom(screenList){
        let to = { secondsrotation: "0", routes: [] }
        to.secondsrotation = screenList.secondsrotation

        screenList.routes.forEach(screen => {
          let obj = {
            idScreen: screen.idScreen,
            parameter: screen.parameter,
            permission: screen.permission,
            rotation: screen.rotation,
            system: screen.system,
            userId: screen.userId,
            userUnitId: screen.userUnitId
          }
          to.routes.push(obj)
        });
        to.routes = to.routes.sort();
        return to
      }

    },

    created() {
      this.loadRotationScreen();
    },
  }
</script>

<style scoped>

.card{
  padding: 8px;
}

.row {
  display: block;
}

.group-buttons{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 5px;
  width: 100%;
}

.color-button{
  margin: 0 4px 4px 0;
  color: #000;
  /* background-color: #343a40; */
  background-color: #fff;
  border: 1px solid #0005;
  border-radius: 4px;
}

.color-button:focus{
  outline: none;
}

.color-button:hover{
  color: #000;
  background-color: #0002;
}

.active-button {
  font-weight: 400;
  color: #fff;
  background-color:  rgb(76, 175, 80);
}

.d-flex{
  display: flex;
  flex-direction: row; 
  align-items: center;
}

.not-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.d-flex>label{
  margin: 0 0 0 5px;
}

.d-flex>.lbl-click {
  cursor: pointer;
}

.d-flex.but{
  background-color: #0002;
  border: 1px solid #0002;
  color: #000;
  border-radius: 5px;
  padding: 0 5px 0 5px;
  cursor: pointer;
}

.on-active, .off-active{
  padding: 7px;
  width: 7px;
  border-radius: 7px;

}

.on-active{
  background-color: rgb(76, 175, 80);
}

.off-active{
  background-color: #ffffff;
}

.active-button:hover {
  font-weight: 400;
  color: #fff;
  background-color:  #4caf5099;
  border: 1 solid #4caf5099;;
}

.groupBtn {
  display: flex;
  justify-content: flex-end;
  margin-right: 5px;
}

img {
  cursor: pointer;
  max-height: 35px;
}

@media (max-width: 427px) { 
  .d-flex.mobile {
    display: block !important;
  }
}
</style>